import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Form, Icon as LegacyIcon } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Button, Input, Row, Col, Select, DatePicker, AutoComplete } from 'antd';
import { dayFormatType, formatDay } from '~helpers/day';

class TransferFilter extends React.Component {
  constructor(props) {
    super(props);
    this.defaultSearchParams = {
      pageNumber: 1,
      pageSize: 10,
    };

    this.state = {
      showMore: true,
      landlordSearchResults: [],
      propertySearchResults: [],
      landlordSlug: null,
      propertySlug: null,
    };

    this.types = ['ALL', 'DEPOSIT', 'FIRST_RENTAL'];
    this.status = ['NEW', 'PENDING_TRANSFER', 'TRANSFERRED'];
    this.payoutMethods = ['ALL', 'BANK_TRANSFER', 'VIRTUAL_CREDIT_CARD', 'STRIPE'];
  }

  handleFiliter = () => {
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (values) {
          const newValues = {
            landlordSlug:
              this.state.landlordSlug && values.landlord ? this.state.landlordSlug : null,
            propertySlug:
              this.state.propertySlug && values.property ? this.state.propertySlug : null,
            orderReferenceId: values.orderReferenceId || null,
            transferType: values.transferType.toLowerCase() !== 'all' ? values.transferType : null,
            statuses: values.statuses?.length > 0 ? values.statuses : [],
            referenceId: values.referenceId || null,
            PlanningTransferDatetimeStart: values.planingTransferDate[0]
              ? formatDay(dayFormatType.FILTERPARAMS, values.planingTransferDate[0])
              : null,
            PlanningTransferDatetimeEnd: values.planingTransferDate[1]
              ? formatDay(dayFormatType.FILTERPARAMS, values.planingTransferDate[1])
              : null,
            ActualTransferDatetimeStart: values.actualTransferDate[0]
              ? formatDay(dayFormatType.FILTERPARAMS, values.actualTransferDate[0])
              : null,
            ActualTransferDatetimeEnd: values.actualTransferDate[1]
              ? formatDay(dayFormatType.FILTERPARAMS, values.actualTransferDate[1])
              : null,
            actualTransferMethod:
              values.actualTransferMethod !== 'ALL' ? values?.actualTransferMethod : null,
          };
          const filters = {
            pageNumber: 1,
            pageSize: 10,
          };

          Object.keys(newValues).map(key => {
            if (newValues[key] || this.props.filters[key]) {
              filters[key] = newValues[key];
            }

            return true;
          });

          this.props.pushState(filters);
        }
      }
    });
  };

  handleResetBtn = () => {
    this.props.form.resetFields();
    this.setState({
      landlordSearchResults: [],
      propertySearchResults: [],
      landlordSlug: null,
      propertySlug: null,
    });
    this.props.history.push({});
  };

  handleShowMoreBtn = () => {
    this.setState({
      showMore: !this.state.showMore,
    });
  };

  handleLandlordChange = e => {
    this.props.searchLandlordList(e, res => {
      this.setState({
        landlordSearchResults: res.search.edges.map(landlord => landlord.node),
      });
    });
  };

  handleLandlordSelect = slug => {
    this.setState({
      landlordSlug: slug,
    });
  };

  handlePropertyChange = e => {
    this.props.searchPropertyList(e, res => {
      this.setState({
        propertySearchResults: res.search.edges.map(property => property.node),
      });
    });
  };

  handlePropertySelect = slug => {
    this.setState({
      propertySlug: slug,
    });
  };

  render() {
    const { t } = this.props;
    const { getFieldDecorator } = this.props.form;
    const dateFormat = dayFormatType.UKFORMAT;

    return (
      <div className="transfer__filter">
        <Form className="transfer__filter__form">
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item
                className="transfer__filter__item"
                label={t('cms.billing.transfer.table.filter.landlord.label')}
              >
                {getFieldDecorator('landlord', {
                  initialValue: this.props.filters.landlord || null,
                })(
                  <AutoComplete
                    onSelect={this.handleLandlordSelect}
                    onChange={this.handleLandlordChange}
                    placeholder={t('cms.billing.transfer.table.filter.landlord.placeholder')}
                  >
                    <For of={this.state.landlordSearchResults} each="item">
                      <AutoComplete.Option key={item.id} value={item.slug}>
                        {item.name}
                      </AutoComplete.Option>
                    </For>
                  </AutoComplete>,
                )}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                className="transfer__filter__item"
                label={t('cms.billing.transfer.table.filter.property.label')}
              >
                {getFieldDecorator('property', {
                  initialValue: this.props.filters.property || null,
                })(
                  <AutoComplete
                    onSelect={this.handlePropertySelect}
                    onChange={this.handlePropertyChange}
                    placeholder={t('cms.billing.transfer.table.filter.property.placeholder')}
                  >
                    <For of={this.state.propertySearchResults} each="item">
                      <AutoComplete.Option key={item.id} value={item.slug}>
                        {item.name}
                      </AutoComplete.Option>
                    </For>
                  </AutoComplete>,
                )}
              </Form.Item>
            </Col>
            <Col
              span={8}
              className={classNames('', { 'transfer__filter__col--hidden': this.state.showMore })}
            >
              <Form.Item
                className="transfer__filter__item"
                label={t('cms.billing.transfer.table.filter.booking_number.label')}
              >
                {getFieldDecorator('orderReferenceId', {
                  initialValue: this.props.filters.orderReferenceId || null,
                })(
                  <Input
                    placeholder={t('cms.billing.transfer.table.filter.booking_number.placeholder')}
                  />,
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row
            gutter={24}
            className={classNames('', { 'transfer__filter__row--hidden': this.state.showMore })}
          >
            <Col span={8}>
              <Form.Item
                className="transfer__filter__item"
                label={t('cms.billing.transfer.table.filter.type.lable')}
              >
                {getFieldDecorator('transferType', {
                  initialValue: this.props.filters.transferType || 'ALL',
                })(
                  <Select>
                    <For of={this.types} each="type">
                      <Select.Option value={type} key={type}>
                        {t(`cms.billing.transfer.table.transfer_type.${type.toLowerCase()}`)}
                      </Select.Option>
                    </For>
                  </Select>,
                )}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                className="transfer__filter__item"
                label={t('cms.billing.transfer.table.filter.status.lable')}
              >
                {getFieldDecorator('statuses', {
                  initialValue: this.props.filters.statuses || undefined,
                })(
                  <Select
                    mode="multiple"
                    maxTagCount={1}
                    placeholder={t('cms.billing.transfer.table.filter.status.lable')}
                  >
                    <For of={this.status} each="type">
                      <Select.Option value={type} key={type}>
                        {t(`cms.billing.transfer.table.transfer_status.${type.toLowerCase()}`)}
                      </Select.Option>
                    </For>
                  </Select>,
                )}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                className="transfer__filter__item"
                label={t('cms.billing.transfer.table.filter.payout_method.lable')}
              >
                {getFieldDecorator('actualTransferMethod', {
                  initialValue: this.props.filters.actualTransferMethod || 'ALL',
                })(
                  <Select>
                    <For of={this.payoutMethods} each="method">
                      <Select.Option value={method} key={method}>
                        {t(
                          `cms.billing.transfer.details.receive_payment_method.${method.toLowerCase()}`,
                        )}
                      </Select.Option>
                    </For>
                  </Select>,
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row
            gutter={24}
            className={classNames('', { 'transfer__filter__row--hidden': this.state.showMore })}
          >
            <Col span={8}>
              <Form.Item
                className="transfer__filter__item"
                label={t('cms.billing.transfer.table.filter.transfer_number.lable')}
              >
                {getFieldDecorator('referenceId', {
                  initialValue: this.props.filters.referenceId || null,
                })(
                  <Input
                    placeholder={t('cms.billing.transfer.table.filter.transfer_number.placeholder')}
                  />,
                )}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                className="transfer__filter__item"
                label={t('cms.billing.transfer.table.filter.planing_transfer_date.lable')}
              >
                {getFieldDecorator('planingTransferDate', {
                  initialValue: [
                    this.props.filters.PlanningTransferDatetimeStart,
                    this.props.filters.PlanningTransferDatetimeEnd,
                  ],
                })(<DatePicker.RangePicker format={dateFormat} onChange={() => {}} />)}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                className="transfer__filter__item"
                label={t('cms.billing.transfer.table.filter.actual_transfer_date.lable')}
              >
                {getFieldDecorator('actualTransferDate', {
                  initialValue: [
                    this.props.filters.ActualTransferDatetimeStart,
                    this.props.filters.ActualTransferDatetimeEnd,
                  ],
                })(<DatePicker.RangePicker format={dateFormat} onChange={() => {}} />)}
              </Form.Item>
            </Col>
          </Row>
          <div
            className={classNames(
              `${this.state.showMore ? 'transfer__filter__btns' : 'transfer__filter__btns-more'}`,
            )}
          >
            <Button onClick={this.handleResetBtn}>
              {t('cms.billing.transfer.table.filter.reset.btn')}
            </Button>
            <Button
              type="primary"
              style={{ margin: '0 12px' }}
              htmlType="submit"
              onClick={this.handleFiliter}
            >
              {t('cms.billing.transfer.table.filter.search.btn')}
            </Button>
            <button onClick={this.handleShowMoreBtn} className="transfer__filter__btn-more">
              {t(`cms.billing.transfer.table.filter.${this.state.showMore ? 'more' : 'less'}.btn`)}
              <LegacyIcon
                type={this.state.showMore ? 'down' : 'up'}
                className="receive__filter__btn-icon"
              />
            </button>
          </div>
        </Form>
      </div>
    );
  }
}

TransferFilter.propTypes = {
  t: PropTypes.func.isRequired,
  filters: PropTypes.object,
  form: PropTypes.object,
  searchLandlordList: PropTypes.func.isRequired,
  searchPropertyList: PropTypes.func.isRequired,
  pushState: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
};

TransferFilter.defaultProps = {
  t: () => {},
  filters: {},
  form: {},
  searchLandlordList: () => {},
  searchPropertyList: () => {},
  pushState: () => {},
  history: {
    push: () => {},
  },
};

export default Form.create()(TransferFilter);
